{
  "nl": {
    "published": {
      "labels": {
        "notPublished": "Niet gepubliceerd",
        "publishedCustomer": "Gepubliceerd voor klanten",
        "publishedCustomerPartners": "Gepubliceerd voor klanten en partners",
        "publishedPartners": "Gepubliceerd voor partners"
      },
      "publish_mode": {
        "inherit": "Sjabloon volgen",
        "inherit_info": "Behoud de gepubliceerde of niet-gepubliceerde status van elk item uit het sjabloon"
      }
    }
  }
}
